/**
 * Created by Codeww
 * on 2019-06-17 18:26
 */
import { StatusBar, Platform } from 'react-native';
import { JDNativeSystem, JDDevice } from '@jdreact/jdreact-core-lib';

import Device from './device';
import globalParams from './globalparams';

const Steep = {
  MOVE_LIMIT: 230,
  NAVIGATION_BAR_HEIGHT: JDDevice.getRpx(88), // 标题栏高度 ios:88px; android:96px web 无自定义标题栏 
  SYS_BAR_HEIGHT:
    // eslint-disable-next-line no-nested-ternary
    Device.isIos() ? JDNativeSystem.statusBarHeight :
      Device.isAndroid() ? (Platform.Version >= 19 ? StatusBar.currentHeight : 0) : 0,
  /**
   * 获取现在的沉浸式头部状态
   */
  getSteepStatus() {
    let isTransparent = globalParams.transparentenable;
    try {
      // 如果传入的是string，则在此处理
      if (typeof isTransparent === 'string') {
        isTransparent = isTransparent === 'true';
      }
    } catch (error) {
      isTransparent = false;
    }
    return isTransparent;
  },
  /**
   * 获取头部透明块的高度
   */
  getSteepBarHeight() {
    let height = 0;
    if (Device.isIos()) {
      height = JDNativeSystem.statusBarHeight;
    } else if (Device.isAndroid()) {
      const transparent = this.getSteepStatus();
      // 小于18的sdk不需要顶部的statusBar
      if (Device.isLowSdkVersion(transparent)) {
        height = 0;
      } else {
        height = StatusBar.currentHeight;
      }
    }
    return height;
  },
  /**
   * 获取内容区域调整大小
   */
  getContainerChangeHeight() {
    let height = 0;
    if (Device.isAndroid()) {
      const transparent = this.getSteepStatus();
      // 小于18的sdk不需要顶部的statusBar
      if (Device.isLowSdkVersion(transparent)) {
        height = 0;
      } else {
        height = StatusBar.currentHeight;
      }
    }
    return height;
  },
  /**
   * 获取导航栏高度
   */
  getNavHeight() {
    let height = this.NAVIGATION_BAR_HEIGHT;
    if (Device.isIos()) {
      height += JDNativeSystem.statusBarHeight;
    } else if (Device.isAndroid()) {
      const transparent = this.getSteepStatus();
      // 小于18的sdk不需要顶部的statusBar
      if (!Device.isLowSdkVersion(transparent)) {
        height += this.SYS_BAR_HEIGHT;
      }
    }
    return height;
  },
};

module.exports = Steep;
